import {Component, OnInit}                                                        from '@angular/core';
import {
    NotificationService
}                                                                                 from "../../services/notification.service";
import {
    ToastServiceHelperService
}                                                                                 from "../../services/toast-service-helper.service";
import {SessionService}                                                           from "../../services/session.service";
import {Notification, PermissionType, SupportRequest, Ticket, TicketStatus, User} from "../../../models";
import {DataStore}                                                                from "@aws-amplify/datastore";
import {ModalController}                                                          from "@ionic/angular";

@Component({
    selector: 'app-new-ticket',
    templateUrl: './new-ticket.component.html',
    styleUrls: ['./new-ticket.component.scss'],
})
export class NewTicketComponent implements OnInit {
    public oggett = '';
    public message = '';
    loading = false;

    constructor(
            private notification: NotificationService,
            private toast: ToastServiceHelperService,
            private sessionService: SessionService,
            public modalController: ModalController,
    ) {
    }

    ngOnInit() {
    }

    async sendRequest() {
        /*  await DataStore.delete(SupportRequest, u => u.message('ne', TicketStatus.WAITINGRESPONSE));
        return   await DataStore.delete(Ticket, u => u.ticketStatus('ne', TicketStatus.WAITINGRESPONSE)); */
        if (this.oggett == '') {
            await this.toast.error('Il campo Oggetto è obbligatori');
            return;
        } else if (this.message == '') {
            await this.toast.error('Il campo Messaggio è obbligatori');
            return;

        }
        
        const u = await DataStore.query(User, this.sessionService.user.id);
        let ticket = await DataStore.save(new Ticket({
            ticketClientId: this.sessionService.user.id,
            client: u,
            ticketStatus: TicketStatus.OPEND,
            title: this.oggett,

        }));
        let firsMessage = await DataStore.save(new SupportRequest({
            message: this.message,
            clientId: this.sessionService.user.id,
            agentId: this.sessionService.user.addedBy,
            ticketId: ticket.id,
            ticket: ticket,
            createdAt: new Date().toISOString(),
            fromUser: u,
            supportRequestFromUserId: this.sessionService.user.id,
            fromId: this.sessionService.user.id,
        }))
        let message = this.message + "<br> " + this.sessionService.user.email;
        await this.toast.success('La tua richiesta è stata inviata con successo');
        try {
            let admins = await DataStore.query(User, condition => condition.permessions('eq', PermissionType.ADMINISTRATOR))
            const msg = "Hai ricevuto un nuovo messaggio da " + this.sessionService.user?.name + " " + this.sessionService.user?.lastname;
            admins.forEach(async u => {
                await this.notification.notify(u.device_id, msg);
            })
            await DataStore.save(new Notification({
                        msg: msg,
                        isAdmin: true,
                        isSeen: false,
                        isOperator: false
                    })
            );
            // let msg = await this.notification.notifyByMail(this.oggett, message, 'admin@digitalshieldtrading.com').toPromise();
            this.modalController.dismiss();
            // 
        } catch (e) {
            
        }

        return;

    }
}
